var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app',[_c('router-view',{staticClass:"d-none d-sm-flex"}),_c('div',{staticClass:"text-center d-sm-none py-16"},[_vm._v("Mobile view does't support")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }